import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

export const useClinicSlice = createSlice({
  name: "fileUploadState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    getSignedUrl: (
      state,
      action: PayloadAction<{
        fileName: string;
        callback: (url: string, prefix: string) => void;
      }>
    ) => {},
    getSignedMultiUrl: (
      state,
      action: PayloadAction<{
        fileNames: string[];
        callback: (urls: string[], prefixes: string[]) => void;
      }>
    ) => {},
    UploadImage: (
      state,
      action: PayloadAction<{
        data: any;
        signedUrl: string;
        result: any;
        callback: () => void;
      }>
    ) => {},
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
